// Función para poblar los selectores
function poblarSelectores() {
    const data = window.TRADEIN_DATA;
    const selectActual = document.getElementById("modeloActual");
    const selectDeseado = document.getElementById("modeloDeseado");

    if (!selectActual || !selectDeseado) return;

    // Limpiar y poner opciones iniciales
    selectActual.innerHTML = '<option value="" disabled selected>Selecciona tu equipo actual</option>';
    selectDeseado.innerHTML = '<option value="" disabled selected>Elige el Equipo que quieres llevarte</option>';

    data.forEach(item => {
        let opt = document.createElement("option");
        opt.value = item["Modelo"];
        opt.textContent = item["Modelo"];
        
        // Verificación de seguridad para el campo "Tipo"
        const tipo = item["Tipo"] ? item["Tipo"].toLowerCase() : "";
        
        if(tipo.includes("trade-in")) {
            selectActual.appendChild(opt.cloneNode(true));
        }
        if(tipo.includes("venta")) {
            selectDeseado.appendChild(opt);
        }
    });
    console.log("✅ Selectores cargados con éxito.");
}

// LÓGICA DE ESPERA CRÍTICA:
// LÓGICA DE ESPERA CRÍTICA ACTUALIZADA
const revisarDatos = setInterval(() => {
    // Si los datos de Google Sheets ya cargaron...
    if (window.TRADEIN_DATA && window.TRADEIN_DATA.length > 0) {
        
        // 1. Llena los selectores de modelos
        poblarSelectores();
        
        // 2. ACTIVA LAS IMÁGENES: Esto le dice a los selectores de fallas
        // que ejecuten la función 'actualizarGaleria' cada vez que alguien cambie una opción.
        document.querySelectorAll(".defecto-select").forEach(sel => {
            // Evitamos que se acumulen eventos
            sel.removeEventListener("change", actualizarGaleria); 
            sel.addEventListener("change", actualizarGaleria);
        });
        
        // 3. Detiene el reloj de espera
        clearInterval(revisarDatos); 
        console.log("✅ Sistema de imágenes y selectores activado.");
    }
}, 100);

// Función para mostrar/ocultar defectos
function toggleDefectos() {
    const procedencia = document.getElementById("compradoEnIp").value;
    const seccionEstado = document.getElementById("seccionEstado");
    const otrosDefectos = document.getElementById("otrosDefectos");

    if (procedencia) {
        seccionEstado.style.display = "block";
        otrosDefectos.style.display = (procedencia === "NO") ? "grid" : "none";
        if (procedencia === "SI") {
            otrosDefectos.querySelectorAll('input').forEach(i => i.checked = false);
        }
    }
}

// Función de cálculo con desglose de descuentos
// Variable global para almacenar el texto del ticket
let mensajeWhatsApp = "";

    // 1. Diccionario de imágenes (Sube tus imágenes a Shopify y pon aquí los links)
    const REFERENCIAS_VISUALES = {
        "CAMARA TRASERA": {
            "0.2": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen6.jpg?v=1777385228",
            "0.6": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen14.jpg?v=1777385228",
            "1": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen19.jpg?v=1777385228"
        },
        "MICA": {
            "0.2": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen3.jpg?v=1777385228",
            "0.6": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen12.jpg?v=1777385228",
            "1": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen18.jpg?v=1777385228"
        },
        "CHASIS": {
            "0.2": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen10.jpg?v=1777385227",
            "0.6": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen7.jpg?v=1777385228",
            "1": "https://cdn.shopify.com/s/files/1/0712/5634/2821/files/Imagen15.jpg?v=1777385228"
        }
    };

function actualizarGaleria() {
    const galeria = document.getElementById("galeriaReferencias");
    if (!galeria) return;

    galeria.innerHTML = ""; 
    let contador = 0;

    // Buscamos todos los selectores de defectos
    const selectores = document.querySelectorAll(".defecto-select");

    selectores.forEach(sel => {
        // Convertimos a mayúsculas y quitamos espacios extras para comparar
        const key = sel.getAttribute("data-key").toUpperCase().trim();
        const valor = sel.value;

        if (REFERENCIAS_VISUALES[key] && REFERENCIAS_VISUALES[key][valor]) {
            contador++;
            const bloque = document.createElement("div");
            bloque.style.marginBottom = "25px";
            bloque.style.textAlign = "center";

            bloque.innerHTML = `
                <p style="font-weight: bold; font-size: 13px; color: #333; margin-bottom: 8px;">
                   📸 Imagen referencia de la ${key.toLowerCase()}:
                </p>
                <img src="${REFERENCIAS_VISUALES[key][valor]}" 
                     style="width: 100%; max-width: 280px; border-radius: 8px; border: 1px solid #ddd; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
            `;
            galeria.appendChild(bloque);
        }
    });

    galeria.style.display = (contador > 0) ? "block" : "none";
}

function calcular() {
    const data = window.TRADEIN_DATA || [];
    const actual = document.getElementById("modeloActual").value;
    const deseado = document.getElementById("modeloDeseado").value;
    const procedencia = document.getElementById("compradoEnIp").value;

    if (!actual || !deseado || !procedencia) {
        alert("Por favor completa los campos.");
        return;
    }

    const equipoEntregado = data.find(d => d["Modelo"] === actual);
    const equipoDeseado = data.find(d => d["Modelo"] === deseado);
    const toNum = val => parseFloat(val) || 0;
    const redondearA5 = val => Math.ceil(val / 5) * 5;

    let valorRecibidoBase = (procedencia === "SI") 
        ? toNum(equipoEntregado["Precio recibido iphonizate"]) 
        : toNum(equipoEntregado["Precio recibido orange"]);

    let totalDescuentos = 0;
    let HTMLdesglose = "";
    let textoDesgloseWA = ""; // Para el mensaje de WhatsApp

    // 2. LÓGICA DE SELECTORES PORCENTUALES
    const selectores = document.querySelectorAll(".defecto-select");
    selectores.forEach(sel => {
        const porcentaje = parseFloat(sel.value);
        if (porcentaje > 0) {
            const key = sel.getAttribute("data-key");
            const montoADescontar = redondearA5(toNum(equipoEntregado[key]) * porcentaje);
            totalDescuentos += montoADescontar;
            
            const nombreFalla = sel.previousElementSibling.innerText.replace(':', '');
            HTMLdesglose += `<div style="display:flex; justify-content:space-between; color:#e03131; font-size:13px; margin-bottom:4px;">
                                <span>- ${nombreFalla} (${porcentaje * 100}%)</span>
                                <span>$${montoADescontar.toFixed(2)}</span>
                             </div>`;
            textoDesgloseWA += `- ${nombreFalla} (${porcentaje * 100}%): -$${montoADescontar.toFixed(2)}\n`;
        }
    });

    // 3. LÓGICA DE CHECKBOXES
    const checkboxes = document.querySelectorAll(".defecto-check:checked");
    checkboxes.forEach(chk => {
        const montoADescontar = redondearA5(toNum(equipoEntregado[chk.value]));
        if (montoADescontar > 0) {
            totalDescuentos += montoADescontar;
            const nombreCheck = chk.parentElement.innerText.trim();
            HTMLdesglose += `<div style="display:flex; justify-content:space-between; color:#e03131; font-size:13px; margin-bottom:4px;">
                                <span>- ${nombreCheck}</span>
                                <span>$${montoADescontar.toFixed(2)}</span>
                             </div>`;
            textoDesgloseWA += `- ${nombreCheck}: -$${montoADescontar.toFixed(2)}\n`;
        }
    });

    const valorFinalEquipo = valorRecibidoBase - totalDescuentos;
    const precioVentaNuevo = toNum(equipoDeseado["Precio venta"]);
    const tarifaServicio = 25;
    const totalPagar = (precioVentaNuevo - valorFinalEquipo) + tarifaServicio;

    const resDiv = document.getElementById("resultado");
    resDiv.style.display = "block";

    if (valorFinalEquipo <= 0) {
        resDiv.innerHTML = `
<div style="background:#fff5f5; border:1px solid #ffc9c9; padding:25px; border-radius:12px; margin-top:15px; text-align:center;">
                <span style="font-size: 40px;">⚠️</span>
                <h3 style="color: #c92a2a; margin: 10px 0;">Equipo no apto para Trade-In</h3>
                <p style="font-size: 14px; color: #555; line-height: 1.5; margin: 0 auto; max-width: 80%;">
                    Lo sentimos, debido al estado técnico actual y el costo proyectado de reacondicionamiento, 
                    este equipo no cumple con los estándares mínimos para nuestro programa de <strong>Trade-In</strong>.
                </p>
                <p style="font-size: 13px; color: #777; margin-top: 15px; font-style: italic;">
                    Te invitamos a visitar nuestra tienda para una evaluación física detallada o explorar nuestras opciones de compra directa.
                </p>
            </div>`;
        document.getElementById("btnWhatsApp").style.display = "none";
    } else {
        resDiv.innerHTML = `
            <div style="background:#fff; border:1px solid #eee; padding:20px; border-radius:12px; margin-top:15px; box-shadow:0 4px 10px rgba(0,0,0,0.05);">
                <p style="margin:0; font-size:14px; display:flex; justify-content:space-between;"><strong>Valor base:</strong> <span>$${valorRecibidoBase.toFixed(2)}</span></p>
                <div style="margin: 10px 0;">${HTMLdesglose}</div>
                <p style="margin:0; font-size:15px; display:flex; justify-content:space-between; color:#2f9e44; border-top:1px dashed #ddd; padding-top:10px;"><strong>Recibimos tu equipo por:</strong> <span>$${valorFinalEquipo.toFixed(2)}</span></p>
                <hr style="border:0; border-top:1px solid #eee; margin:15px 0;">
                <div style="text-align:center;">
                    <span style="font-size:14px; color:#666;">Diferencia a pagar:</span>
                    <h2 style="margin:5px 0; font-size:32px; color:#333;">$${totalPagar.toFixed(2)}</h2>
                    <p style="margin-top:10px; font-size:12px; color:#777; font-style: italic;">
                        Se ha aplicado una tarifa de $25.00 por el servicio de trade-in.
                    </p>
                </div>
            </div>`;
        
        // CONSTRUCCIÓN DEL MENSAJE PARA WHATSAPP
        mensajeWhatsApp = `*COTIZACIÓN TRADE-IN IPHONÍZATE*\n\n` +
                          `📱 *Equipo que entrega:* ${actual}\n` +
                          `🎯 *Equipo que desea:* ${deseado}\n` +
                          `🏢 *Procedencia:* ${procedencia === 'SI' ? 'Iphonízate' : 'Otro'}\n\n` +
                          `💰 *Valor Base:* $${valorRecibidoBase.toFixed(2)}\n` +
                          `*Descuentos por estado:*\n${textoDesgloseWA || '- Sin detalles adicionales\n'}\n` +
                          `✅ *Valor retoma de su equipo:* $${valorFinalEquipo.toFixed(2)}\n` +
                          `💵 *Diferencia final a pagar:* $${totalPagar.toFixed(2)}\n\n` +
                          `_Se ha aplicado una tarifa de $25.00 por el servicio de trade-in._`; // Añadido al mensaje

        document.getElementById("btnWhatsapp").style.display = "inline-block";
        document.getElementById("btnWhatsapp").onclick = enviarWhatsApp;
        document.getElementById("proTips").style.display = "block";
    }
}

function enviarWhatsApp() {
    const telefono = "584142101257"; 
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensajeWhatsApp)}`;
    window.open(url, '_blank');
}